import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../Container/Container';

import { TXTWCL_Something_went_wrong } from './DepositResultUnknown.messages.json';

const DepositResultUnknown: React.FC = () => (
  <Container
    page={DepositResultUnknown}
    headerProps={{
      title: <Translation {...TXTWCL_Something_went_wrong} />,
      buttons: {}
    }}
    showFooter
  />
);

DepositResultUnknown.displayName = 'DepositResultUnknown';

export default DepositResultUnknown;
